import { Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation } from '@angular/core';

import { ReportIncorrectDetails } from './report-incorrect-details.model';
import { ReportIncorrectDetailsService } from './report-incorrect-details.service';
import { WebApiModel } from '../../models/web-api.model';
import { StateService } from '../../services/state.service';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'hcf-report-form',
  templateUrl: './report-form.component.html',
  styleUrls: ['./report-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ReportFormComponent implements OnChanges {
  @Input() person: WebApiModel.Person;
  @Input() personFullName: string;
  @Input() place: WebApiModel.Place;
  @Output() closePopupHandler = new EventEmitter();

  // Enum object with items that can be reported
  reportItem = {
    name: 'name',
    phone: 'phone',
    fax: 'fax',
    web: 'web',
    email: 'email',
    address: 'address',
  };
  reportType: number = null;
  reportResult: ReportIncorrectDetails;
  reportSubmittedSuccess: boolean = false;
  reportSubmittedError: boolean = false;

  private _checkBoxCount: number = 0;
  private _captchaResponse: string = null;

  constructor(
    private _uiService: UiService,
    private _stateService: StateService,
    private _reportService: ReportIncorrectDetailsService,
  ) {}

  ngOnChanges() {
    this.reportResult = new ReportIncorrectDetails();
    // Reset the report type, it fill trigger ngIf and it will reset the radio and checkbox state
    this.reportType = null;

    if (this.person) {
      this.reportResult.reportType = 'person';
      this.reportResult.id = this.person.id;
    } else if (this.place) {
      this.reportResult.reportType = 'place';
      this.reportResult.id = this.place.id;
    } else {
      return;
    }

    this.reportResult.url = this._uiService.getCurrentUrl();
  }

  reportIncorrectDetails() {
    if (this.formIsValid()) {
      this._stateService.isComponentLoading(true);

      this._reportService.sendReport(this.reportResult).subscribe(
        (response: boolean) => {
          if (response) {
            this.reportSubmittedError = false;
            this.reportSubmittedSuccess = true;
          } else {
            this.reportSubmittedSuccess = false;
            this.reportSubmittedError = true;
          }
          this._stateService.isComponentLoading(false);
          this._uiService.scrollToTop();
        },
        () => {
          // Show an error message
          this.reportSubmittedSuccess = false;
          this.reportSubmittedError = true;
          this._stateService.isComponentLoading(false);
          this._uiService.scrollToTop();
        },
      );
    }
  }

  selectReportType(reportType: number) {
    if (this.reportType !== reportType) {
      this.reportType = reportType;
      this._checkBoxCount = 0; // When switching the report type all checkboxes are reset so we reset the count.
    }
  }

  /** Adds/removes options from the final report object when checkboxes are selected
   */
  optionCheck(event, reportItem: string) {
    if (!event.target) {
      return;
    }

    const t = event.target;

    let itemValue = null;

    if (t.checked) {
      itemValue = t.value;
      this._checkBoxCount++;
    } else {
      this._checkBoxCount--;
    }

    if (reportItem === this.reportItem.name) {
      this.reportResult.name = itemValue;
    } else if (reportItem === this.reportItem.fax) {
      this.reportResult.fax = itemValue;
    } else if (reportItem === this.reportItem.web) {
      this.reportResult.webAddress = itemValue;
    } else if (reportItem === this.reportItem.email) {
      this.reportResult.emailAddress = itemValue;
    } else if (reportItem === this.reportItem.address) {
      this.reportResult.address = itemValue;
    } else if (reportItem === this.reportItem.phone) {
      if (!this.reportResult.phones) {
        this.reportResult.phones = [];
      }
      if (t.checked) {
        this.reportResult.phones.push(t.value);
      } else {
        this.reportResult.phones = this.reportResult.phones.filter((x) => x !== t.value);
      }
    }

    // Custom checkbox icons require a class set on the label element,
    // Find current checkbox parent label and toggle the class 'checked'
    this._uiService.toggleParentClass(t, 'label', 'checked');
  }

  formIsValid() {
    return this._checkBoxCount > 0 && this._captchaResponse;
  }

  captchaResolved(captchaResponse: string) {
    this._captchaResponse = captchaResponse;
    this.reportResult.captchaResponse = captchaResponse;
  }

  done() {
    this._stateService.closePopup();
  }

  tryAgain() {
    this.reportSubmittedSuccess = false;
    this.reportSubmittedError = false;
    this._captchaResponse = null;
  }
}
